// extracted by mini-css-extract-plugin
export default {"root":"root___XBhz0","icon":"icon___GlRJS","filled":"filled___duVWz","beatingAnimation":"beatingAnimation___mfoqU","beating":"beating___Xsdff"};